// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../fonts/Urbanist-VariableFont_wght.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: 'Urbanist';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}); }

.NationalStreamQualityAccountingNetwork {
  color: #fff;
  background-color: #050e25;
  height: 90vh;
  width: calc(100% - 10px);
  margin: 0px;
  padding: 0px;
  padding-left: 15px;
  padding-right: 15px;
  padding-top: 10px; }
  .NationalStreamQualityAccountingNetwork .expand-container {
    position: absolute;
    top: 65px !important;
    left: 70px;
    height: 90vh !important;
    width: 95%;
    z-index: 100;
    flex-direction: column; }
  .NationalStreamQualityAccountingNetwork .expand-container .table-container {
    max-height: 84vh !important;
    margin-left: 15px !important;
    min-height: 84vh !important; }
  .NationalStreamQualityAccountingNetwork .attribution-container {
    margin-top: 40px; }
  .NationalStreamQualityAccountingNetwork .mapboxgl-popup {
    max-width: 335px !important; }
  .NationalStreamQualityAccountingNetwork .mapboxgl-popup-content {
    padding: 0px;
    min-width: 375px !important;
    padding: 0px !important;
    opacity: .95;
    border-radius: 4px;
    width: 100% !important;
    background-color: #18244c; }
  .NationalStreamQualityAccountingNetwork .mapboxgl-popup-close-button {
    display: none; }
  .NationalStreamQualityAccountingNetwork .mapboxgl-popup-anchor-top .mapboxgl-popup-tip {
    border-bottom-color: #18244c;
    opacity: .8; }
  .NationalStreamQualityAccountingNetwork .popup-container {
    padding-top: 7px;
    padding-bottom: 32px;
    padding-left: 10px;
    padding-right: 4px;
    font-size: 14px;
    min-width: 375px;
    background-color: #050E25;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    width: max-content;
    font-weight: 500;
    opacity: .95;
    text-align: center;
    height: 195px;
    line-height: 10px;
    font-family: "Urbanist";
    display: flex;
    flex-direction: column;
    width: max-content; }
  .NationalStreamQualityAccountingNetwork .popup-content {
    display: flex;
    flex-direction: row;
    justify-content: flex-start; }
  .NationalStreamQualityAccountingNetwork .popup-container h4 {
    font-size: 20px;
    line-height: 20px;
    min-height: 42px;
    color: #4fc2d9; }
  .NationalStreamQualityAccountingNetwork .popup-content-left {
    text-align: right;
    margin-right: 10px;
    min-width: 90px;
    max-width: 90px;
    line-height: 14px;
    white-space: pre-wrap; }
  .NationalStreamQualityAccountingNetwork .popup-content-left p {
    margin-bottom: 10px; }
  .NationalStreamQualityAccountingNetwork .popup-content-right {
    text-align: left;
    max-width: 290px;
    min-width: 250px;
    line-height: 14px;
    font-size: 18px;
    padding-right: 2px; }
  .NationalStreamQualityAccountingNetwork .popup-content-right p {
    margin-bottom: 10px; }
  .NationalStreamQualityAccountingNetwork .popup-content-right-double {
    height: 22px;
    line-height: 18px; }
  .NationalStreamQualityAccountingNetwork .popup-content-right-triple {
    height: 32px;
    line-height: 16px; }
  .NationalStreamQualityAccountingNetwork .container {
    display: flex;
    padding: 0;
    height: 90%;
    margin-top: 8px;
    max-width: inherit; }
    .NationalStreamQualityAccountingNetwork .container input,
    .NationalStreamQualityAccountingNetwork .container select {
      margin-bottom: 50px; }
    .NationalStreamQualityAccountingNetwork .container .main-col {
      max-width: -webkit-fill-available; }
    .NationalStreamQualityAccountingNetwork .container .map-title {
      width: auto;
      white-space: nowrap;
      position: absolute;
      left: 59px;
      top: 0px;
      font-size: 1.25rem;
      padding: 5px;
      z-index: 90; }
    .NationalStreamQualityAccountingNetwork .container .table-container {
      background-color: #0b1736;
      border-radius: 2px;
      box-shadow: 0px 0px 20px #000;
      display: flex;
      position: relative;
      margin-left: 1px;
      margin-top: 10px;
      max-height: 38vh;
      overflow-y: auto; }
    .NationalStreamQualityAccountingNetwork .container .reportTable {
      min-height: 10vh;
      color: white; }
    .NationalStreamQualityAccountingNetwork .container .map-best-container {
      background-color: #0b1736;
      border-radius: 2px;
      box-shadow: 0px 0px 20px #000;
      display: flex;
      position: relative;
      height: 38vh;
      width: 100%;
      border-radius: 7px;
      padding: 0px !important; }
    .NationalStreamQualityAccountingNetwork .container .map-legend {
      width: 195px;
      position: absolute;
      border-radius: 5px;
      padding: 5px;
      right: 40px;
      bottom: 10px;
      padding-bottom: 10px;
      background-color: #18244c;
      z-index: 90; }
    .NationalStreamQualityAccountingNetwork .container .map-legend p {
      text-align: center;
      height: 15px; }
    .NationalStreamQualityAccountingNetwork .container .map-legend span {
      width: 100px;
      margin-left: 5px; }
    .NationalStreamQualityAccountingNetwork .container .map-legend-div {
      display: flex;
      flex-flow: column;
      height: 100%;
      flex-wrap: wrap; }
    .NationalStreamQualityAccountingNetwork .container .map-legend-dot-div {
      width: 70px;
      margin-left: 5px;
      white-space: nowrap; }
    .NationalStreamQualityAccountingNetwork .container .map-legend-dot {
      background-color: #4b5ea6;
      height: 14px;
      width: 14px;
      margin-left: 5px;
      margin-right: 5px;
      border-radius: 50%;
      display: inline-flex; }
    .NationalStreamQualityAccountingNetwork .container .expand-container-summary {
      position: absolute;
      top: 59px;
      left: 50px;
      height: 90vh !important;
      width: 95% !important;
      z-index: 100;
      padding-top: 45px !important;
      overflow: scroll !important;
      flex-flow: wrap; }
    .NationalStreamQualityAccountingNetwork .container .expand-summary-button {
      display: unset;
      position: absolute;
      top: 1px;
      left: 0px;
      z-index: 1001; }
    .NationalStreamQualityAccountingNetwork .container .te-primary {
      background-color: #050e25; }
    .NationalStreamQualityAccountingNetwork .container .te-secondary {
      background-color: #4fc32c; }
    .NationalStreamQualityAccountingNetwork .container .te-blue {
      background-color: #0b61bf; }
    .NationalStreamQualityAccountingNetwork .container .report-options {
      margin-top: 20px;
      text-align: right;
      margin-right: 8px;
      height: 30px; }
      .NationalStreamQualityAccountingNetwork .container .report-options button {
        background-color: #fff;
        border: unset;
        margin-left: 10px; }
      .NationalStreamQualityAccountingNetwork .container .report-options button:hover {
        background-color: #0b1736; }
    .NationalStreamQualityAccountingNetwork .container .report-options-button-container {
      width: 200px;
      display: inline-flex;
      flex-flow: row-reverse;
      background-color: #050e25; }

@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: portrait) {
  .NationalStreamQualityAccountingNetwork .header-container h2 {
    font-size: 28px; } }
`, "",{"version":3,"sources":["webpack://./src/theme/_variables.scss","webpack://./src/features/reports/NationalStreamQualityAccountingNetwork/styles.scss"],"names":[],"mappings":"AAqBA;EACE,uBAAuB;EACvB,4CAAmD,EAAA;;AChBrD;EACE,WDRqB;ECSrB,yBDIsC;ECHtC,YAAY;EACZ,wBAAwB;EACxB,WAAW;EACX,YAAY;EACZ,kBAZoB;EAapB,mBAboB;EAcpB,iBAbmB,EAAA;EAIrB;IAaI,kBAAkB;IAClB,oBAAoB;IACpB,UAAU;IACV,uBAAuB;IACvB,UAAU;IACV,YAAY;IACZ,sBAAsB,EAAA;EAnB1B;IAuBI,2BAA2B;IAC3B,4BAA4B;IAC5B,2BAA2B,EAAA;EAzB/B;IA6BI,gBAAgB,EAAA;EA7BpB;IAiCI,2BAA2B,EAAA;EAjC/B;IAqCI,YAAY;IACZ,2BAA2B;IAC3B,uBAAuB;IACvB,YAAY;IACZ,kBAAkB;IAClB,sBAAsB;IACtB,yBAAyB,EAAA;EA3C7B;IA+CI,aAAa,EAAA;EA/CjB;IAmDI,4BAA4B;IAC5B,WAAW,EAAA;EApDf;IAwDI,gBAAgB;IAChB,oBAAoB;IACpB,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,2BAA2B;IAC3B,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,iBAAiB;IACjB,uBAAuB;IACvB,aAAa;IACb,sBAAsB;IACtB,kBAAkB,EAAA;EA3EtB;IA+EI,aAAa;IACb,mBAAmB;IACnB,2BAA2B,EAAA;EAjF/B;IAsFI,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,cAAc,EAAA;EAzFlB;IA6FI,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,iBAAiB;IACjB,qBAAqB,EAAA;EAlGzB;IAsGI,mBAAmB,EAAA;EAtGvB;IA0GI,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;IACf,kBAAkB,EAAA;EA/GtB;IAmHI,mBAAmB,EAAA;EAnHvB;IAuHI,YAAY;IACZ,iBAAiB,EAAA;EAxHrB;IA4HI,YAAY;IACZ,iBAAiB,EAAA;EA7HrB;IAiII,aAAa;IACb,UAAU;IACV,WAAW;IACX,eAAe;IACf,kBAAkB,EAAA;IArItB;;MAyIM,mBAAmB,EAAA;IAzIzB;MA6IQ,iCAAiC,EAAA;IA7IzC;MAiJQ,WAAW;MACX,mBAAmB;MACnB,kBAAkB;MAClB,UAAU;MACV,QAAQ;MACR,kBAAkB;MAClB,YAAY;MACZ,WAAW,EAAA;IAxJnB;MA4JQ,yBDhKwB;MCiKxB,kBAAkB;MAClB,6BAA6B;MAC7B,aAAa;MACb,kBAAkB;MAClB,gBAAgB;MAChB,gBAAgB;MAChB,gBAAgB;MAChB,gBAAgB,EAAA;IApKxB;MAwKQ,gBAAgB;MAChB,YAAY,EAAA;IAzKpB;MA6KM,yBDjL0B;MCkL1B,kBAAkB;MAClB,6BAA6B;MAC7B,aAAa;MACb,kBAAkB;MAClB,YAAY;MACZ,WAAW;MACX,kBAAkB;MAClB,uBAAuB,EAAA;IArL7B;MAyLM,YAAY;MACZ,kBAAkB;MAClB,kBAAkB;MAClB,YAAY;MACZ,WAAW;MACX,YAAY;MACZ,oBAAoB;MACpB,yBAAyB;MACzB,WAAW,EAAA;IAjMjB;MAqMM,kBAAkB;MAClB,YAAY,EAAA;IAtMlB;MA0MM,YAAY;MACZ,gBAAgB,EAAA;IA3MtB;MA+MM,aAAa;MACb,iBAAiB;MACjB,YAAY;MACZ,eAAe,EAAA;IAlNrB;MAsNM,WAAU;MACV,gBAAgB;MAChB,mBAAmB,EAAA;IAxNzB;MA4NM,yBAAyB;MACzB,YAAY;MACZ,WAAW;MACX,gBAAgB;MAChB,iBAAiB;MACjB,kBAAkB;MAClB,oBAAoB,EAAA;IAlO1B;MAsOM,kBAAkB;MAClB,SAAS;MACT,UAAU;MACV,uBAAuB;MACvB,qBAAqB;MACrB,YAAY;MACZ,4BAA4B;MAC5B,2BAA2B;MAC3B,eAAe,EAAA;IA9OrB;MAkPM,cAAc;MACd,kBAAkB;MAClB,QAAQ;MACR,SAAS;MACT,aAAa,EAAA;IAtPnB;MA2PM,yBAAyB,EAAA;IA3P/B;MA+PM,yBAAyB,EAAA;IA/P/B;MAmQM,yBAAyB,EAAA;IAnQ/B;MAwQM,gBAAgB;MAChB,iBAAiB;MACjB,iBAAiB;MACjB,YAAY,EAAA;MA3QlB;QA8QQ,sBAAsB;QACtB,aAAa;QACb,iBAAiB,EAAA;MAhRzB;QAoRQ,yBAAyB,EAAA;IApRjC;MAyRQ,YAAY;MACZ,oBAAoB;MACpB,sBAAsB;MACtB,yBAAyB,EAAA;;AAKjC;EACE;IAGM,eAAe,EAAA,EAChB","sourcesContent":["$primaryFontColor: #fff;\n$secundaryFontColor: #4fc2d9;\n$thirdFontColor: #0b1736;\n$topMenuBackgroundColor: #0b1736;\n$sideBackgroundColor: #002044;\n$sideSubMenuBackgroundColor: #0b1736;\n$fontFamily: 'Urbanist';\n$leftMenuWidth: 5rem;\n$rightMenuWidth: 400px;\n$navBrandImageSize: 150px;\n$darkAndLightModeBackgroundColor: #12234f;\n$dropdownFiltersBackgroundColor: #060e21;\n$inputFocusBackgroundColor: #060e21;\n$containerScreenBackgroundColor: #050e25;\n$tableBackgroundColor: #0b1736;\n$secondarySubtitleColor: #838487;\n\n//FORMS\n$inputBackgroundColor: #021d3e;\n$btnPrimary: #257ee0;\n\n@font-face {\n  font-family: 'Urbanist';\n  src: url('../fonts/Urbanist-VariableFont_wght.ttf');\n}\n","@import \"../../../theme/_variables.scss\";\n\n$paddingLeftSize: 15px;\n$paddingTopSize: 10px;\n\n$positionTop: 130px;\n\n.NationalStreamQualityAccountingNetwork {\n  color: $primaryFontColor;\n  background-color: $containerScreenBackgroundColor;\n  height: 90vh;\n  width: calc(100% - 10px);\n  margin: 0px;\n  padding: 0px;\n  padding-left: $paddingLeftSize;\n  padding-right: $paddingLeftSize;\n  padding-top: $paddingTopSize;\n\n\n  .expand-container {\n    position: absolute;\n    top: 65px !important;\n    left: 70px;\n    height: 90vh !important;\n    width: 95%;\n    z-index: 100;\n    flex-direction: column;\n  }\n\n  .expand-container .table-container{\n    max-height: 84vh !important;\n    margin-left: 15px !important;\n    min-height: 84vh !important;\n  }\n\n  .attribution-container {\n    margin-top: 40px;\n  }\n    \n  .mapboxgl-popup {\n    max-width: 335px !important;\n  }\n\n  .mapboxgl-popup-content {\n    padding: 0px;\n    min-width: 375px !important;\n    padding: 0px !important;\n    opacity: .95;\n    border-radius: 4px;\n    width: 100% !important;\n    background-color: #18244c;\n  }\n\n  .mapboxgl-popup-close-button{\n    display: none;\n  }\n\n  .mapboxgl-popup-anchor-top .mapboxgl-popup-tip {\n    border-bottom-color: #18244c;\n    opacity: .8;\n  }    \n\n  .popup-container {\n    padding-top: 7px;\n    padding-bottom: 32px;\n    padding-left: 10px;\n    padding-right: 4px;\n    font-size: 14px;\n    min-width: 375px;\n    background-color: #050E25;\n    display: flex;\n    flex-direction: row;\n    justify-content: flex-start;\n    width: max-content;\n    font-weight: 500;\n    opacity: .95;\n    text-align: center;\n    height: 195px;\n    line-height: 10px;\n    font-family: \"Urbanist\";\n    display: flex;\n    flex-direction: column;\n    width: max-content;\n  }\n\n  .popup-content {\n    display: flex;\n    flex-direction: row;\n    justify-content: flex-start;\n  }\n\n  \n  .popup-container h4{\n    font-size: 20px;\n    line-height: 20px;\n    min-height: 42px;\n    color: #4fc2d9;\n  }\n\n  .popup-content-left {\n    text-align: right;\n    margin-right: 10px;\n    min-width: 90px;\n    max-width: 90px;\n    line-height: 14px;\n    white-space: pre-wrap;\n  }\n\n  .popup-content-left p{\n    margin-bottom: 10px;\n  }\n\n  .popup-content-right {\n    text-align: left;\n    max-width: 290px;\n    min-width: 250px;\n    line-height: 14px;\n    font-size: 18px;\n    padding-right: 2px;\n  }\n\n  .popup-content-right p{\n    margin-bottom: 10px;\n  }\n\n  .popup-content-right-double{\n    height: 22px;\n    line-height: 18px;\n  }\n\n  .popup-content-right-triple{\n    height: 32px;\n    line-height: 16px;\n  }\n\n  .container {\n    display: flex;\n    padding: 0;\n    height: 90%;\n    margin-top: 8px;\n    max-width: inherit;\n\n    input,\n    select {\n      margin-bottom: 50px;\n    }\n\n    .main-col {\n        max-width: -webkit-fill-available;\n    }\n\n    .map-title {\n        width: auto;\n        white-space: nowrap;\n        position: absolute;\n        left: 59px; \n        top: 0px;\n        font-size: 1.25rem;\n        padding: 5px;\n        z-index: 90;\n     }\n\n     .table-container {\n        background-color: $topMenuBackgroundColor;\n        border-radius: 2px;\n        box-shadow: 0px 0px 20px #000;\n        display: flex;\n        position: relative;\n        margin-left: 1px;\n        margin-top: 10px;\n        max-height: 38vh;\n        overflow-y: auto;\n      }\n\n      .reportTable {\n        min-height: 10vh;\n        color: white;\n      }\n\n    .map-best-container {\n      background-color: $topMenuBackgroundColor;\n      border-radius: 2px;\n      box-shadow: 0px 0px 20px #000;\n      display: flex;\n      position: relative;\n      height: 38vh;\n      width: 100%;\n      border-radius: 7px;\n      padding: 0px !important;\n    }\n\n    .map-legend {\n      width: 195px;\n      position: absolute;\n      border-radius: 5px;\n      padding: 5px;\n      right: 40px; \n      bottom: 10px;\n      padding-bottom: 10px;\n      background-color: #18244c;\n      z-index: 90;\n    }\n\n    .map-legend p{\n      text-align: center;\n      height: 15px;\n    }\n  \n    .map-legend span{\n      width: 100px;\n      margin-left: 5px;\n    }\n\n    .map-legend-div {\n      display: flex;\n      flex-flow: column;\n      height: 100%;\n      flex-wrap: wrap;\n    }\n\n    .map-legend-dot-div{\n      width:70px;\n      margin-left: 5px;\n      white-space: nowrap;\n    }\n\n    .map-legend-dot {\n      background-color: #4b5ea6;\n      height: 14px;\n      width: 14px;\n      margin-left: 5px;\n      margin-right: 5px;\n      border-radius: 50%;\n      display: inline-flex;\n    }\n\n    .expand-container-summary {\n      position: absolute;\n      top: 59px;\n      left: 50px;\n      height: 90vh !important;\n      width: 95% !important;\n      z-index: 100;\n      padding-top: 45px !important;\n      overflow: scroll !important;\n      flex-flow: wrap;\n    }\n\n    .expand-summary-button {\n      display: unset;\n      position: absolute;\n      top: 1px;\n      left: 0px;\n      z-index: 1001;\n    }\n\n\n    .te-primary {\n      background-color: #050e25;\n    }\n\n    .te-secondary {\n      background-color: #4fc32c;\n    }\n\n    .te-blue {\n      background-color: #0b61bf;\n    }\n\n\n    .report-options {\n      margin-top: 20px;\n      text-align: right;\n      margin-right: 8px;\n      height: 30px;\n\n      button {\n        background-color: #fff;\n        border: unset;\n        margin-left: 10px;\n      }   \n       \n      button:hover {\n        background-color: #0b1736;\n      }\n    }\n\n    .report-options-button-container {\n        width: 200px;\n        display: inline-flex;\n        flex-flow: row-reverse;\n        background-color: #050e25;\n    }\n  }\n}\n\n@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: portrait) {\n  .NationalStreamQualityAccountingNetwork {\n    .header-container {\n      h2 {\n        font-size: 28px;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
